import { forwardRef as u, isValidElement as s, Children as g, cloneElement as d } from "react";
import { u as v } from "../../../floating-ui.react-CreHqeI3.js";
import P from "../hooks/usePopoverContext.js";
const a = u(({ children: e, ...i }, t) => {
  const {
    context: {
      open: o
    },
    refs: p,
    getReferenceProps: c
  } = P(), r = (() => {
    if (typeof e == "function") {
      const n = e({ isOpen: o, forwardedRef: t });
      if (!s(n))
        throw new Error("Function child of MarketPopoverTrigger must return a valid React element");
      return n;
    }
    if (g.count(e) !== 1)
      throw new Error("MarketPopoverTrigger must have exactly one child element");
    if (!s(e))
      throw new Error("MarketPopoverTrigger requires a valid React element as children");
    return e;
  })(), f = r.ref, m = v([p.setReference, t, f]), l = {
    "data-status": o ? "open" : "closed",
    ref: m,
    ...i
  };
  return d(
    r,
    {
      ...c(l),
      ...r.props
    }
  );
});
a.displayName = "MarketPopoverTrigger";
const E = a;
export {
  a as ForwardedMarketPopoverTrigger,
  E as MarketPopoverTrigger
};
